module.exports = __webpack_public_path__ + "img/pp-08.bbb52676.jpg";